import english from './english.json'
import kannada from './kannada.json'
import hindi from './hindi.json'

export default { english, kannada, hindi }